import axios from 'axios'
import * as types from '../mutation-types'
import {Cookies} from 'quasar-framework'

const API_PATH = `${config.SkySMSUrl}/settings/user-preferences`

// state
export const state = {
    user_categories: []
}

// getters
export const getters = {
    user_categories: state => state.user_categories,
}

// mutations
export const mutations = {
    [types.FETCH_CATEGORIES_SUCCESS] (state, {user_categories}) {
        state.user_categories = user_categories
    },

    [types.UPDATE_CATEGORIES] (state, {user_categories}) {
        state.user_categories = user_categories
    }
}

// actions
export const actions = {
    async fetchCategories ({commit}) {
        try {
            let portal_base = Cookies.get('portal')
            let user = Cookies.get('user')
            if (!portal_base) {
                await axios.get(`${config.PortalBase}/get-portals`)
                    .then((response) => {
                        if (response.data.length > 0) {
                            portal_base = response.data[0].portal.id
                            Cookies.set('portal', portal_base, {expires: 1, path: '/'})
                        }
                    })
            }
            const {data} = await axios.get(`${config.appUrl}/${portal_base}/${user}/user-categories`)

            commit(types.FETCH_CATEGORIES_SUCCESS, {user_categories: data})
        } catch (e) {
        }
    },
    updateCategories ({commit,dispatch}, payload) {
        commit(types.UPDATE_CATEGORIES, payload)
        try {
            axios.post(`${API_PATH}`, {payload})
                .finally(async () => {
                    dispatch('fetchCategories')
                })
        } catch (e) {
            console.log(e)
        }
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/categories.js